(function () {
  var header = document.querySelector(".site-header");
  var backdrop = document.querySelector(".site-header-backdrop");
  if (!header) {
    return;
  }

  var lastY = window.scrollY;
  var ticking = false;

  function update() {
    var currentY = window.scrollY;

    // Com o mega-menu ou a busca do mobile abertos (search-toggle.js), o
    // header fica parado — evita esconder o campo enquanto se digita (o
    // teclado do celular pode rolar a página).
    if (!document.body.classList.contains("nav-open") && !document.body.classList.contains("search-open")) {
      if (currentY > lastY && currentY > 80) {
        header.classList.add("site-header--hidden");
        if (backdrop) backdrop.classList.add("site-header-backdrop--hidden");
      } else {
        header.classList.remove("site-header--hidden");
        if (backdrop) backdrop.classList.remove("site-header-backdrop--hidden");
      }
    }

    lastY = currentY;
    ticking = false;
  }

  window.addEventListener(
    "scroll",
    function () {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    },
    { passive: true }
  );
})();
